export default [
  {"id":"learn-index","index":true,"component":"LearnIndexRedirect","guard":"none"},
  {"id":"learn-home","path":"library","component":"LearnHome","guard":"none"},
  {"id":"learn-course","path":"courses/:courseId","component":"LearnCourse","guard":"none"},
  {"id":"learn-course-purpose","path":"courses/:courseId/:purposeId","component":"LearnPurposeView","guard":"none"},
  {"id":"learn-unit","path":"courses/:courseId/units/:unitId","component":"LearnUnit","guard":"none"},
  {"id":"learn-document","path":"documents/:documentId","component":"LearnDocumentPending","guard":"none"},
  {"id":"learn-fallback","path":"*","component":"LearnNotFound","guard":"none"}
];
